import Http from './Http';

const endpoint = 'user-options';

const userOptions = {
	getUserOptions() {
		return Http.get(endpoint);
	},

	updateUserOptions(data) {
		return Http.put(endpoint, data);
	},
};

export default userOptions;
